import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserPermissionsService } from './user-permissions.service';

/**
 * Blocks routes that exist only to create or modify data. Hiding the buttons
 * keeps read-only users from reaching these screens by accident; this stops a
 * bookmark, a back-button, or a hand-typed URL from getting there anyway.
 *
 * Redirects to the parent project (or the dashboard) rather than showing an
 * error, since arriving here is not the user's mistake.
 */
export const readOnlyGuard: CanActivateFn = (route) => {
  const permissions = inject(UserPermissionsService);
  const router = inject(Router);

  if (permissions.canModify()) {
    return true;
  }

  const projectId =
    route.paramMap.get('projectId') ?? route.parent?.paramMap.get('projectId') ?? null;

  return router.createUrlTree(projectId ? ['/projects', projectId] : ['/']);
};
